import * as React from 'react';
import { ArticleHeading3, ArticleParagraph1, Image } from '@cian/ui-kit';

import { BottomContent, PromoItemLabel } from './parts';
import * as styles from './PromoItem.css';
import { IPromo } from '../../types/promosPage';

interface IPromoItemProps {
  promo: IPromo;
  onClick?(): void;
}

export const PromoItem = React.forwardRef<HTMLDivElement, IPromoItemProps>(({ promo, onClick }, ref) => {
  return (
    <article ref={ref} className={styles['card']} onClick={onClick} role="button" tabIndex={0} data-testid="PromoItem">
      <div className={styles['top-content']}>
        <div>
          <div className={styles['labels']}>
            {promo.labels.map(({ text, type }) => (
              <PromoItemLabel key={type} newbuildingIds={promo.newbuildingIds} text={text} type={type} />
            ))}
          </div>
          <ArticleHeading3 as="h3" data-testid="PromoItemHeading">
            {promo.name}
          </ArticleHeading3>
          <div className={styles['provider']}>
            <ArticleParagraph1>{promo.providerName}</ArticleParagraph1>
          </div>
        </div>
        <div className={styles['logo']}>
          <Image
            src={promo.providerLogo}
            height="100%"
            width="100%"
            objectFit="contain"
            data-testid="PromoItemProviderLogo"
          />
        </div>
      </div>
      <BottomContent promoProps={promo.promoProps} />
    </article>
  );
});

PromoItem.displayName = 'PromoItem';
